import { render, staticRenderFns } from "./DoorphoneAdMetricsPanel.vue?vue&type=template&id=9067bf1c&scoped=true"
import script from "./DoorphoneAdMetricsPanel.vue?vue&type=script&lang=js"
export * from "./DoorphoneAdMetricsPanel.vue?vue&type=script&lang=js"
import style0 from "./DoorphoneAdMetricsPanel.vue?vue&type=style&index=0&id=9067bf1c&prod&lang=scss&scoped=true"
import style1 from "./DoorphoneAdMetricsPanel.vue?vue&type=style&index=1&id=9067bf1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9067bf1c",
  null
  
)

export default component.exports